module.exports = __webpack_public_path__ + "img/scratchcover.873732fc.png";